export let hres7deColumns = () => {
  let indexColumns = [{
    key: 'codcours',
    name: '',
    labelCodapp: 'HRES7DE2',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'name',
    name: '',
    labelCodapp: 'HRES7DE2',
    labelIndex: '60',
    style: 'min-width: 200px;'
  }, {
    key: 'numclseq',
    name: '',
    labelCodapp: 'HRES7DE2',
    labelIndex: '70',
    style: 'min-width: 120px;',
    class: 'align-center'
  }, {
    key: 'nam_tparg',
    name: '',
    labelCodapp: 'HRES7DE2',
    labelIndex: '80',
    style: 'min-width: 180px;'
  }, {
    key: 'v_dteinput',
    name: '',
    labelCodapp: 'HRES7DE2',
    labelIndex: '90',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'dtecert',
    name: '',
    labelCodapp: 'HRES7DE2',
    labelIndex: '95',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }]

  let detailTab3Columns = [{
    key: 'codinst',
    name: '',
    labelCodapp: 'HRES7DEP3',
    labelIndex: '10',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codinst',
    name: '',
    labelCodapp: 'HRES7DEP3',
    labelIndex: '20',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'codsubj',
    name: '',
    labelCodapp: 'HRES7DEP3',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codsubj',
    name: '',
    labelCodapp: 'HRES7DEP3',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'qtyscore',
    name: '',
    labelCodapp: 'HRES7DEP3',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'qtyemp',
    name: '',
    labelCodapp: 'HRES7DEP3',
    labelIndex: '60+70',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'destrevl',
    name: '',
    labelCodapp: 'HRES7DEP3',
    labelIndex: '80',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'trainingDate',
    name: '',
    labelCodapp: 'HRES7DEP3',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'dtetrst',
    name: '',
    labelCodapp: 'HRES7DEP3',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1,
    dataType: 'date'
  }, {
    key: 'dtetren',
    name: '',
    labelCodapp: 'HRES7DEP3',
    labelIndex: '110',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1,
    dataType: 'date'
  }]

  let detailTab1PopupBtn1to3Columns = [{
    key: 'numques',
    name: '',
    labelCodapp: 'STDTRTEST1',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 80px;'
  }, {
    key: 'desc_exam',
    name: '',
    labelCodapp: 'STDTRTEST1',
    labelIndex: '110',
    style: 'min-width: 120px;'
  }, {
    key: 'qtytest',
    name: '',
    labelCodapp: 'STDTRTEST1',
    labelIndex: '130',
    class: 'align-right',
    style: 'min-width: 100px;',
    summary: true
  }, {
    key: 'qtyscore',
    name: '',
    labelCodapp: 'STDTRTEST1',
    labelIndex: '120',
    class: 'align-right',
    style: 'min-width: 100px;',
    summary: true
  }]

  let detailTab1PopupBtn4Columns = [{
    key: 'numques',
    name: '',
    labelCodapp: 'STDTRTEST2',
    labelIndex: '10',
    class: 'align-center',
    style: 'min-width: 80px;'
  }, {
    key: 'question',
    name: '',
    labelCodapp: 'STDTRTEST2',
    labelIndex: '20',
    style: 'min-width: 120px;'
  }, {
    key: 'answer',
    name: '',
    labelCodapp: 'STDTRTEST2',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'qtyques',
    name: '',
    labelCodapp: 'STDTRTEST2',
    labelIndex: '40',
    class: 'align-right',
    style: 'min-width: 100px;',
    summary: true
  }, {
    key: 'qtytest',
    name: '',
    labelCodapp: 'STDTRTEST2',
    labelIndex: '50',
    class: 'align-right',
    style: 'min-width: 100px;',
    summary: true
  }]

  return {
    en: {
      index: indexColumns,
      detailTab1PopupBtn1to3: detailTab1PopupBtn1to3Columns,
      detailTab1PopupBtn4: detailTab1PopupBtn4Columns,
      detailTab3: detailTab3Columns
    },
    th: {
      index: indexColumns,
      detailTab1PopupBtn1to3: detailTab1PopupBtn1to3Columns,
      detailTab1PopupBtn4: detailTab1PopupBtn4Columns,
      detailTab3: detailTab3Columns
    }
  }
}
export let hres7deMaxRowspan = {
  detailTab3: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres7de.js